import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, PartnerFunds } from 'components';
import { showApiError } from 'utils';
import { getPartnerFundsBalance } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PartnerFundsTab = function PartnerFundsTab(_ref) {
  var partner = _ref.partner;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      balance = _useState2[0],
      setBalance = _useState2[1];

  useEffect(function () {
    (partner === null || partner === void 0 ? void 0 : partner.id) && fetchFundsBalance();
  }, [partner === null || partner === void 0 ? void 0 : partner.id]);

  var fetchFundsBalance = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getPartnerFund, _yield$getPartnerFund2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPartnerFundsBalance({
                partner_id: partner === null || partner === void 0 ? void 0 : partner.id
              });

            case 2:
              _yield$getPartnerFund = _context.sent;
              _yield$getPartnerFund2 = _slicedToArray(_yield$getPartnerFund, 2);
              res = _yield$getPartnerFund2[0];
              err = _yield$getPartnerFund2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setBalance(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchFundsBalance() {
      return _ref2.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref3) {
      var _balance$total_balanc;

      var css = _ref3.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0421\u0440\u0435\u0434\u0441\u0442\u0432\u0430"), ___EmotionJSX("div", null, ___EmotionJSX("h5", null, "\u0411\u0430\u043B\u0430\u043D\u0441: ", (_balance$total_balanc = balance === null || balance === void 0 ? void 0 : balance.total_balance) !== null && _balance$total_balanc !== void 0 ? _balance$total_balanc : 0, " ", balance === null || balance === void 0 ? void 0 : balance.currency)));
    },
    margin: "0 0 2em 0"
  }, (partner === null || partner === void 0 ? void 0 : partner.id) && ___EmotionJSX(PartnerFunds, {
    partnerId: partner === null || partner === void 0 ? void 0 : partner.id
  }))));
};

PartnerFundsTab.propTypes = {
  partner: PropTypes.object
};
export default PartnerFundsTab;